export var hasOptions = options => Array.isArray(options);
export var useMinAndMax = _ref => {
  var {
    minFromUser,
    maxFromUser,
    options
  } = _ref;
  return {
    min: options && hasOptions(options) ? options[0] : minFromUser ? minFromUser : 0,
    max: options && hasOptions(options) ? options[options.length - 1] : maxFromUser ? maxFromUser : 100
  };
};
export var getFancyState = isFancy => isFancy ? 'fancy' : 'default';
export var calculateStepPx = _ref2 => {
  var {
    knobSize,
    max,
    width
  } = _ref2;
  return (width - knobSize) / max;
};
export var calculatePosition = _ref3 => {
  var {
    value,
    stepPx
  } = _ref3;
  return value * stepPx;
};
var getClosestNumber = (arr, target) => arr.reduce((prev, next) => {
  var isNextCloser = Math.abs(next - target) < Math.abs(prev - target);
  return isNextCloser ? next : prev;
});
export var calculatePositionChange = _ref4 => {
  var {
    knobSize,
    max,
    min,
    onChange,
    options,
    step,
    stepPx,
    value,
    x
  } = _ref4;
  var nextValue = value;

  // non-linear
  if (options && hasOptions(options)) {
    var steps = (x - knobSize / 2) / stepPx;
    nextValue = getClosestNumber(options, steps);
    // linear
  }

  if (step) {
    var _steps = Math.floor((x - knobSize / 2) / stepPx / step);
    nextValue = _steps * step;
  }
  if (onChange) {
    if (nextValue < min) {
      onChange(min);
    } else if (nextValue > max) {
      onChange(max);
    } else {
      onChange(nextValue);
    }
  }
};
//# sourceMappingURL=utils.js.map